
import { Vue } from 'vue-property-decorator';
import { Auth } from '@aws-amplify/auth';
import { Logger } from '@aws-amplify/core';

const logger = new Logger('FlightPathNewPassword');

export default Vue.extend({
  name: 'FlightpathNewPassword',
  props: {
    dialog: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      loader: null,
      loading: false,
      formState: 'default',
      errorMessage: null,
      errorExists: false,
      user: null,
      form: {
        username: '',
        password: '',
        code: ''
      }
    };
  },
  methods: {
    async forgotPassword() {
      try {
        await Auth.forgotPassword(this.form.username);
        this.formState = 'forgot';
      } catch (error) {
        this.errorExists = true;
        const translationKey = 'auth.error.' + error.code;
        const translationExists = this.$te(translationKey);
        const message = translationExists ? this.$t('auth.error.' + error.code) : error.message;
        this.errorMessage = message;
      }
    },
    cancel() {
      this.formState = 'default';
      this.$emit('update:dialog', false);
    },
    async confirmPassword() {
      this.errorExists = false;
      this.errorMessage = null;
      const { username, password, code } = this.form;
      this.loading = true;
      try {
        await Auth.forgotPasswordSubmit(username, code, password);
        await Auth.signIn(username, password);
        this.formState = 'default';
      } catch (error) {
        logger.warn('error confirm new password', error);
        this.loading = false;
        this.loader = null;
        this.errorExists = true;
        const translationKey = 'auth.error.' + error.code;
        const translationExists = this.$te(translationKey);
        const message = translationExists ? this.$t('auth.error.' + error.code) : error.message;
        this.errorMessage = message;
      }
    }
  }
});
